import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { CitiesAmountHelper, SmartCitiesHelper, HighlightedCitiesHelper } from 'app/shared/objects/cities';
import { DashNumbers } from 'app/shared/objects/main';
import { HighlightSolution } from 'app/shared/highlight-solution/highlight-solution.component';
import { HighlightedSolution } from 'app/shared/objects/solutions';


@Injectable()
export class HomeService {


  constructor(private http: HttpClient) {
  }

  getCitiesAmount(): Promise<CitiesAmountHelper> {
    return this.http.get(environment.apiURL + '/frontEndOpen/dashboardCitiesAmount')
    .toPromise()
      .then(response => {
          return response as CitiesAmountHelper;
      })
      .catch(error => {
        return null;
      });
  }
  getDashboardNumbers(): Promise<DashNumbers> {
    return this.http.get(environment.apiURL + '/frontEndOpen/dashboardNumbers')
    .toPromise()
      .then(response => {
        return response as DashNumbers;
      })
      .catch(error => {
        return null;
      });
  }
  getSmartCities(): Promise<SmartCitiesHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/smartCities')
        .toPromise()
        .then(response => {
            return response as SmartCitiesHelper[];
        })
        .catch(error => {
          return null;
        });
  }
  getHighlightedCities(): Promise<HighlightedCitiesHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/highlightedCities')
        .toPromise()
        .then(response => {
            return response as HighlightedCitiesHelper[];
        })
        .catch(error => {
          return null;
        });
  }
  getSearchSmartCities(search: string): Promise<SmartCitiesHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/searchCity/' + search )
        .toPromise()
        .then(response => {
            return response as SmartCitiesHelper[];
        })
        .catch(error => {
          return null;
        });
  }

  getCityById(cityId: string): Promise<SmartCitiesHelper> {
    return this.http.get(environment.apiURL + '/frontEndOpen/cityProfile/' + cityId)
        .toPromise()
        .then(response => {
            // Extract city info from profile response
            const data = response as any;
            if (data) {
                const city = new SmartCitiesHelper();
                city.id = data.id || cityId;
                city.name = data.name || data.cityName || '';
                city.region = data.region || data.state || '';
                city.country = data.country || '';
                return city;
            }
            return null;
        })
        .catch(error => {
          console.log('Error fetching city by ID:', cityId, error);
          return null;
        });
  }

  postHighlightSolutions(items: string[]): Promise<HighlightedSolution[]> {
    return this.http.post(environment.apiURL+'/frontEndOpen/highlightedSolutions', items)
      .toPromise()
      .then(response => {
        return response as HighlightedSolution[];
      })
      .catch(error => {
        return null;
      });
  }

  getHighlightedCitiesHome(itens: number): Promise<HighlightedCitiesHelper[]> {
    return this.http.get(environment.apiURL + '/frontEndOpen/highlightedCities/' + itens)
        .toPromise()
        .then(response => {
            return response as HighlightedCitiesHelper[];
        })
        .catch(error => {
          return null;
        });
  }

  getPlansOpen(id): Promise<any> {
    return this.http.get(environment.apiURL + '/frontEndOpen/plans/'+id)
    .toPromise()
    .then(response => {
      return response;
    })
    .catch(error => {
      return null;
    });
  }
}

export class PlanPrice {
  priceId: string;
  recurrenceType: RecurrenceTypes;
  currencyType: string;
  value: number;
};

export class Plan {
  id: string;
  name: string;
  description: string;
  usersAllowed: number;
  freeTrialPeriodInDays: number;
  hasIsoCertification: boolean;
  prices: PlanPrice[];
  features: PlanFeatures[];
  planType: string;
  billingId: string;
  active: number;
};

export enum RecurrenceTypes {
  MONTHLY = "MONTHLY",
  ANNUAL = "ANNUAL",
}

export interface PlanFeatures {
  code: string;
  description: string;
  enabled: boolean;
  name: string;
  translations: string;
  value: string;
  stampUrl: string;
}